import { SessionStorage } from './sessionStorage.enum';
export var ProfileType;
(function (ProfileType) {
    ProfileType["CLIENT"] = "CLIENT";
    ProfileType["PARTNER"] = "PARTNER";
    ProfileType["OFFICIAL"] = "OFFICIAL";
})(ProfileType || (ProfileType = {}));
export const ProfileTypeTranslation = {
    [ProfileType.CLIENT]: 'Klient',
    [ProfileType.PARTNER]: 'Partner',
    [ProfileType.OFFICIAL]: 'Urzędnik'
};
/**
 * Sprawdza, czy zalogowany użytkownik jest klientem
 *
 * @export
 * @returns {boolean}
 */
export function isClient() {
    return localStorage.getItem(SessionStorage.PROFILE_TYPE) === ProfileType.CLIENT;
}
/**
 * Sprawdza, czy zalogowany użytkownik jest urzędnikiem
 *
 * @export
 * @returns {boolean}
 */
export function isOfficial() {
    return localStorage.getItem(SessionStorage.PROFILE_TYPE) === ProfileType.OFFICIAL;
}
/**
 * Sprawdza, czy zalogowany użytkownik jest partnerem
 *
 * @export
 * @returns {boolean}
 */
export function isPartner() {
    return localStorage.getItem(SessionStorage.PROFILE_TYPE) === ProfileType.PARTNER;
}
//# sourceMappingURL=profileType.enum.js.map